import React from 'react'
import { SvgIconOwnProps } from '@mui/material/SvgIcon/SvgIcon'
import { StyledCustomIcon } from './styles'

export const HealthIcon: React.FC<SvgIconOwnProps> = ({ color }) => {
  return (
    <StyledCustomIcon
      color={color}
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 256 256'
      height='24'
      width='24'
    >
      <metadata> Svg Vector Icons : http://www.onlinewebfonts.com/icon</metadata>
      <g>
        <g>
          <g>
            <path d='M67.8,18.6C53.4,20.1,38.7,27.9,29,39.1C18.4,51.2,12.5,65.4,10.3,83.9c-1.9,16.8,4.7,39.9,16.5,57.7l3.3,5h13.6h13.6l10.5-23.2c5.7-12.7,11-23.6,11.6-24.3c1.5-1.5,4.3-1.5,5.8,0c0.7,0.6,5.6,12.4,12.6,30c6.3,15.9,11.6,29,11.7,29c0,0.1,4-6.9,8.7-15.4c4.7-8.5,9.1-16.1,9.7-16.8c0.9-1.1,1.5-1.3,3.1-1.3c2.5,0,2.9,0.5,7.5,8.1c2,3.3,3.7,5.9,3.8,5.8c0.1-0.1,3.5-16.2,7.7-35.8c4.1-19.6,7.7-36.4,8-37.2c1-3.1,4.5-3.9,6.9-1.7l1.4,1.3l6.4,40.7l6.4,40.7h23.5H226l3.2-4.8c11.7-17.7,18.3-40.5,16.6-57.6c-2.7-27-16.2-48.7-36.8-59.2c-9.3-4.8-16.3-6.4-27-6.4c-13.2,0-23.9,3.2-34.9,10.5c-4.2,2.8-11.4,9.6-14.9,14c-2.9,3.7-3,3.8-4.9,3.8c-1.3,0-1.8-0.4-3.7-2.9c-8.8-11.5-18.3-18.4-30.6-22.5C85.4,18.8,75.5,17.8,67.8,18.6z' />
            <path d='M161.2,92.2c-0.2,2.3-12.9,60.9-13.3,61.4c-1.4,1.8-4,2.5-5.9,1.4c-0.5-0.2-3-4.1-5.7-8.6c-2.7-4.5-5-8.2-5.2-8.2c-0.1,0-4.4,7.4-9.5,16.5c-5,9.1-9.6,16.9-10.1,17.4c-1.2,1.1-4.2,1.1-5.5,0c-0.5-0.5-5.7-12.8-12.2-29.1c-6.2-15.6-11.4-28.5-11.6-28.7c-0.1-0.2-4.4,8.6-9.3,19.5c-5,10.9-9.5,20.2-9.9,20.7c-0.8,0.7-2.3,0.8-13,0.9l-12.1,0.1l0.8,1.2c0.5,0.7,20.1,18.6,43.6,40c23.5,21.3,43.3,39.3,43.9,39.9l1.2,1.1l42.5-37.8c23.3-20.8,43.8-39.3,45.5-41l3-3.1l-22.5-0.2c-21.2-0.2-22.5-0.3-23.5-1.1c-0.5-0.5-1.1-1.2-1.2-1.6c-0.1-0.4-2.3-14.1-4.9-30.4C162,95.1,161.3,91.1,161.2,92.2z' />
          </g>
        </g>
      </g>
    </StyledCustomIcon>
  )
}
